<template>
    <div class="header">
        <div class="header-within">
            <div class="header-top">
                <div style="width: 1200px; margin: 0 auto;display: flex;justify-content: space-between;align-items: center;">
                    <div class="header-top-left">
                        <img src="../assets/img/home/home-top-logo.png" alt="" class="logo" />
                        <div class="top-left-text">
                            <div class="text">“齐质享” NQI一站式云服务平台</div>
                            <div class="bottom-text">"QiZHIXIANG" NQI one-stop cloud service platform</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box" style="width: 100%">
                <div class="navigation" :default-active="$route.path">
                    <div
                        class="view"
                        :class="tab == 0 ? 'isActive' : ''"
                        @click="tabClick(tab = 0)"
                    >
                        <div class="top">首页</div>
                    </div>
                    <div
                        class="view"
                        :class="tab == 1 ? 'isActive' : ''"
                       @click="tabClick(tab = 1)"
                    >
                        <!-- <a href="../lianheti" target="_blank" class="top">计量服务</a> -->
                        <div class="dropdown">
                            <el-dropdown  @command="handleCommand">
                                <span class="el-dropdown-link">
                                    <span style="flex: 1; text-align: center; z-index: 100;"  class="top">计量服务 </span><i class="down"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="legislationService">计量法律法规</el-dropdown-item>
                                    <el-dropdown-item command="jiliangnengli">计量能力</el-dropdown-item>
                                    <el-dropdown-item command="jiliangService">计量服务方案</el-dropdown-item>
                                    <el-dropdown-item command="jiliangOnlineService">计量线上服务</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!-- <div class="top">联合体</div> -->
                    </div>
                    <div
                        class="view"
                        :class="tab == 2 ? 'isActive' : ''"
                        @click="tabClick(tab = 2)"
                    >
                        <!-- <div class="top">标准化服务</div> -->
                        <el-dropdown  @command="handleCommandBiaozhunhuafuwu">
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">标准化服务 </span><i class="down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="biaozhunhuaLegislation">标准化法律法规</el-dropdown-item>
                                <el-dropdown-item command="biaozhunchaxun">标准查询</el-dropdown-item>
                                <el-dropdown-item command="biaozhunService xiuding">标准制修订服务</el-dropdown-item>
                                <el-dropdown-item command="biaozhunService xiangmujianshe">标准化项目建设服务</el-dropdown-item>
                                <el-dropdown-item command="biaozhunService shangpintiaoma">商品条码服务</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    
                    <div
                        class="view"
                        :class="tab == 3 ? 'isActive' : ''"
                        @click="tabClick(tab = 3)"
                    >
                        <!-- <div class="top">认证认可服务</div> -->
                        <el-dropdown  @command="handleCommandRenzhengjianyan">
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">认证认可服务 </span><i class="down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="renzhengjianyanLegislation">认证检验检测政策法规</el-dropdown-item>
                                <el-dropdown-item command="">
                                    <a href="http://218.57.139.17:9900/JYJCWEB/" class="desc" target="_blank">检验检测能力信息查询</a>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <div class="top">共同体</div> -->
                    </div>
                    <div
                        class="view"
                        :class="tab == 4 ? 'isActive' : ''"
                        @click="tabClick(tab = 4)"
                    >
                        <!-- <div class="top">检验检测服务</div> -->
                        <div class="dropdown">
                            <el-dropdown  @command="handleCommandJiance">
                                <span class="el-dropdown-link">
                                    <span style="flex: 1; text-align: center; z-index: 100;"  class="top">检验检测服务 </span><i class="down"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="jiancenengli">检测能力</el-dropdown-item>
                                    <el-dropdown-item command="jianyanService">检验服务方案</el-dropdown-item>
                                    <el-dropdown-item command="jianyanOnlineService">检验检测线上服务</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <div class="view">
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">
                                    <a href="https://www.zibosei.cn/portal/index" target="_blank">特种设备</a> 
                                </span><i class="down"></i>
                            </span>
                        </el-dropdown>
                    </div>
                    <div
                        class="view"
                        :class="tab == 5 ? 'isActive' : ''"
                        @click="tabClick(tab = 5)"
                    >
                        <el-dropdown  @command="handleCommandQualityService">
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">质量服务 </span><i class="down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="qualityLegislation">质量政策法规</el-dropdown-item>
                                <el-dropdown-item command="qualityBrand">品牌建设</el-dropdown-item>
                                <el-dropdown-item command="">
                                    <a href="https://msa.zibo.gov.cn/col/col9717/index.html" target="_blank">产品质量抽查结果查询</a>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="view">
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">
                                    <a href="https://zscqj.zibo.gov.cn/" target="_blank">知识产权</a> 
                                </span><i class="down"></i>
                            </span>
                        </el-dropdown>
                    </div>
                    <!-- <div
                        class="view"
                        :class="tab == 6 ? 'isActive' : ''"
                        @click="tabClick(tab = 6)"
                    >
                        <div class="top">品牌建设</div>
                    </div> -->
                    <div
                        class="view"
                        :class="tab == 7 ? 'isActive' : ''"
                        @click="tabClick(tab = 7)"
                    >
                    <!-- 人才培训 -->
                        <div class="top">质量专家</div>
                    </div>
                    <div
                        class="view"
                        :class="tab == 8 ? 'isActive' : ''"
                        @click="tabClick(tab = 8)"
                    >
                        <div class="top">服务机构</div>
                    </div>
                    <div
                        class="view"
                        :class="tab == 10 ? 'isActive' : ''"
                        @click="tabClick(tab = 10)"
                    >
                        <div class="top">NQI站点</div>
                    </div>
                    <!-- <div
                        class="view"
                        :class="tab == 9 ? 'isActive' : ''"
                        @click="tabClick(tab = 9)"
                    >
                        <el-dropdown  @command="handleCommandChuJuService">
                            <span class="el-dropdown-link">
                                <span style="flex: 1; text-align: center; z-index: 100;"  class="top">临淄厨具服务</span><i class="down"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="item in cjTitle" :command="item">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->
                </div>
            </div>
            <!-- <img src="../../public/banner/shouyebanner.png" alt="" class="header-banner" v-show="tab==0">
      <img src="../../public/banner/rencaizhengce.png" alt="" class="header-banner" v-show="tab==1">
      <img src="../../public/banner/rencaimabanner.png" alt="" class="header-banner" v-show="tab==3">
      <img src="../../public/banner/rencaigongchengbanner.png" alt="" class="header-banner" v-show="tab==4">
      <img src="../../public/banner/guaishuai.png" alt="" class="header-banner" v-show="tab==10">
      <img src="../../public/banner/rencaichaoshi.png" alt="" class="header-banner" v-show="tab==11">
      <img src="../../public/banner/rencaifuwu.png" alt="" class="header-banner" v-show="tab==12"> -->
        </div>
    </div>
</template>

<script>
import { color } from "echarts";
import { mapMutations, mapState } from "vuex";
import { Server } from "@/server";
export default {
    name: "Header",
    data() {
        return {
            tab: this.$store.state.CommonHeader.tab ? this.$store.state.CommonHeader.tab : 0, //0：首页   1：信息公开    2：国际经贸促进   3：国际联络    4：会展服务    5：投资促进    6：商事法律    7：国际商会    8：关于我们

            select: '/',

            RouteState:true,

            searchName: "", // 搜索框输入的文字


            pageType: '',
            cjTitle: []
        };
    },
    computed: {
        ...mapState("CommonHeader", ["nav", "Games", "isShowli"]),
        counts() {
            return this.$store.state.CommonHeader.tab;
        },
    },
    mounted() {
        //强制转化到首页
        // this.tab = this.counts;
        // this.tabClick(this.tab);//0
        // console.log('1111111111111111' +  this.tab)
        this.getlzcjfwTitle()
    },
    methods: {
        ...mapMutations("CommonHeader", ["Flagt", "Flagf"]),
        // 输入框的方法
        toSearch(event) {
            if(event) {
                event.target.blur()
            }
            this.tabClick(10);
            console.log(this.searchName);
            console.log(this.$route.path);
            if(this.$route.path == '/searchResult') {
                this.RouteState = false;
                this.$nextTick(()=>{
                    this.RouteState = true;
                });
            }

            // this.RouteState = false;
            // this.$nextTick(()=>{
            //     this.RouteState = true;
            // });
            
            this.$router.push({
                path: '/searchResult',
                query: {
                    tab: '10',
                    value: this.searchName
                }
            })
            // this.$router.options.routes.forEach(item => {
            //     if(item.path == '/searchResult') {
            //         this.$router.options.routes.slice(item, 1)
            //         console.log(this.$router.options.routes);
            //     }
            //     this.$router.push({
            //         path: '/searchResult',
            //         query: {
            //             tab: '10',
            //             value: this.searchName
            //         }
            //     })
            // })
            
            console.log(this.$router);
        },

        getlzcjfwTitle() {

            Server.getlzcjfwTitle({}).then(res => {
                console.log(res);
                if(res.success) {
                    this.cjTitle = res.result.records
                }
            })
        },

        tabClick(tab) {
            console.log(this.tab);
            this.$store.state.CommonHeader.tab = tab;
            this.tab = tab ?tab : 0
            console.log(tab == 0);
            if (tab == 0) {
                // this.$router.push("/home");

                this.select = '/home'
                sessionStorage.setItem('tab', this.select)
                this.$router.push({
                    path: this.select,
                    query: {
                        tab: this.tab
                    },
                })
            } else if (tab == 6) {
                this.$router.push({
                    path: '/brandBuild'
                })
            } else if (tab == 7) {
                this.$router.push({
                    path: '/talentsTrain'
                })
            } else if (tab == 8) {
                this.$router.push({
                    path: '/serviceOrganization'
                    // path: '/shareShiyanshi'
                })
            } else if (tab == 9) {
                this.$router.push({
                    path: '/kitchenwareMain'
                })
            } else if (tab == 10) {
                this.$router.push({
                    path: '/NQI'
                })
            }
        },

        handleCommand(command) {
            if (command == 'jiliangOnlineService') {
                window.open('http://www.zbqim.com.cn/','_blank')
                return
            }
            this.$router.push({
                path: command,
                query: {

                },
            })
        },

        handleCommandJiance(command) {
            if (command == 'jianyanOnlineService') {
                window.open('http://www.zbqim.com.cn/','_blank')
                return
            }
            this.$router.push({
                path: command,
                query: {
                    
                },
            })
        },

        handleCommandBiaozhunhuafuwu(command) {
            console.log(command);
            
            if(command.indexOf('biaozhunService') >= 0) {
                console.log(this.$router);
                this.$router.push({
                    path: '/biaozhunService',
                    query: {
                        pageType: command.split(' ')[1]
                    }
                })
            } else {
                this.$router.push({
                    path: command,
                    query: {

                    }
                })
            }
            
        },

        handleCommandRenzhengjianyan(command) {
            this.$router.push({
                path: command,
                query: {}
            })
        },

        handleCommandQualityService(command) {
            this.$router.push({
                path: command,
                query: {}
            })
        },

        handleCommandChuJuService(command) {
            this.$router.push({
                path: '/chujuSub',
                query:{
                typename:command.title
                }
            })
            // this.$router.push({
            //     path: 'cjContent',
            //     query: {
            //         id:command.id,
            //         title:command.title
            //     }
            // })
        }
    },
    created() {
        // 在页面加载时读取sessionStorage
        if (sessionStorage.getItem("select")) {
            this.$store.replaceState(
                Object.assign(
                    {},
                    this.$store.state,
                    JSON.parse(sessionStorage.getItem("select"))
                )
            );
        }
        // 在页面刷新时将store保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("select", JSON.stringify(this.$store.state));
        });
    },
    
    watch: {
        counts(newVal, oldVal) {
            this.tab = newVal;
        },
    },
};
</script>

<style lang="less" scoped>
.header {
    width: 100%;
    //   width: 100%;
    overflow: hidden;
    // margin-left: 100px;
    margin: 0 auto;
    background-color: #fff;
    

    .header-within {
        width: 100%;
        position: relative;
        z-index: 10;

        .box {
            width: 100%;
            // background: #0527AF;
            height: 50px;
            // margin-top: 20px;
            display: flex;
            align-items: center;
        }
        .navigation {
            width: 1100px;
            margin: 0 auto 10px;
            height: 100%;

            display: flex;
            justify-content: space-between;
            z-index: 10;
            .view {
                height: 100%;
                // width: 20%;
                flex: 1;
                font-weight: bold;
                cursor: pointer;

                display: flex;
                align-items: center;
                justify-content: center;
                .dropdown {
                    width: 100%;
                    height: 100%;
                }
                
                .top {
                    text-align: center;
                    // margin-top: 13px;
                    font-size: 14px;
                    color: #333;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .view.isActive {
                border-bottom: 3px solid #027BFF;
                color: #027BFF;
                .top {
                    color: #027BFF;
                    font-weight: bold;
                }
            }
        }
        // .header-banner {
        //   width: 100%;
        //   height: 336px;
        // }

        .header-top {
            width: 100%;
            
            padding: 15px 25px;
            // width: calc(100% - 40px);
             
            background-image: url('@/assets/img/home/home-top.png');
            background-size: 100% 100%;
            .header-top-left {
                display: flex;
                align-items: end;
                .logo {
                    // width: 62px;
                    height: 55px;
                }
                .top-left-text {
                    color: #010101;
                    margin-left: 15px;
                    .text {
                        font-size: 22px;
                        font-weight: bold;
                        margin-bottom: 5px;
                    }
                    .bottom-text {
                        font-size: 14px;
                    }
                }
            }
            .right {
                width: 15%;
                text-align: center;
            }
            .header-top-right {
                text-align: center;
                // border: 1px solid #b5b5b5;
                // border-radius: 30px;
                // display: flex;
                // justify-content: space-between;
                height: 40px;
                line-height: 38px;
                // align-items: center;
                font-size: 14px;
                .left {
                    width: 100%;
                    text-align: center;
                    text-align: center;
                    color: #fff;
                }
                .right {
                    width: 120px;
                    text-align: center;
                    color: #fff;
                }
                .center {
                    width: 1px;
                    height: 100%;
                    background-color: #fff;
                }
            }
        }
        .top-bottom {
            width: 100%;
            height: 350px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
::v-deep .el-dropdown {
    width: 100%;
    height: 100%;
    
}
.el-dropdown-menu__item {
    text-align: center;
    font-weight: bold;
}
/* pad */
@media screen and (max-width: 1199px) and (min-width: 600px) {
    .header {
        width: 1000px;
        overflow: hidden;
        // height: 520px;
        margin-left: 100px;
        margin: 0 auto;
        .header-within {
            width: 100%;
            position: relative;

            .navigation {
                display: flex;
                justify-content: space-between;
                background: #005190;
                margin-top: 20px;
                padding: 0 20px;
                height: 40px;
                .view {
                    border-radius: 10px;
                    margin-top: 3px;
                    height: 90%;
                    width: 13%;
                    cursor: pointer;
                    .top {
                        text-align: center;
                        margin-top: 13px;
                        font-size: 18px;
                        color: #ffffff;
                    }
                    .bottom {
                        text-align: center;
                        margin-top: 13px;
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .header-banner {
                width: 100%;
                height: 336px;
            }

            .header-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;
                width: calc(100% - 40px);

                .header-top-logo {
                    padding-left: 40px;
                    /*background-color: #e9852d;*/
                    /*  margin-top: 0px;*/
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .header-top-right {
                    border: 1px solid #b5b5b5;
                    border-radius: 30px;
                    padding: 10px 0;
                    display: flex;
                    justify-content: space-between;
                    height: 40px;
                    align-items: center;
                    .left {
                        width: 120px;
                        text-align: center;
                        color: #555;
                    }
                    .right {
                        width: 120px;
                        text-align: center;
                        color: #555555;
                    }
                    .center {
                        width: 1px;
                        height: 100%;
                        background-color: #b5b5b5;
                    }
                }
            }
        }
    }
}
/* 移动端 */
</style>
